import {
  Table as CSDTable,
  TableProps,
} from "@cloudscape-design/components-themed";
import { ICancellationItems, LABELS } from "./constants";
import TableEmptyState from "../UI/TableEmptyState";

interface ICancellationTable {
  items: ICancellationItems[];
}

// 解約連携情報テーブルのカラム定義
const columnDefinitions: TableProps.ColumnDefinition<ICancellationItems>[] = [
  {
    id: "cancellationTarget",
    header: "解約連携先",
    cell: (item: ICancellationItems) => item.cancellationTarget,
  },
  {
    id: "cancellationRequestDate",
    header: LABELS.CANCELLATION_REQUEST_DATE,
    cell: (item: ICancellationItems) => item.cancellationRequestDate,
  },
  {
    id: "cancellationAnswerDate",
    header: LABELS.CANCELLATION_ANSWER_DATE,
    cell: (item: ICancellationItems) => item.cancellationAnswerDate,
  },
  {
    id: "cancellationStatus",
    header: LABELS.CANCELLATION_STATUS,
    cell: (item: ICancellationItems) => item.cancellationStatus,
  },
];

/**
 * 解約連携情報一覧
 */
const CancellationTable = (props: ICancellationTable) => {
  const { items } = props;

  return (
    <CSDTable
      columnDefinitions={columnDefinitions}
      items={items}
      empty={<TableEmptyState />}
      resizableColumns
    />
  );
};

export default CancellationTable;

